export default "__VITE_ASSET__B6W0utHX__"